import React from 'react'
import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { ColoredBar } from '../ColoredBar/ColoredBar'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    manaBarColorBg: {
      backgroundColor: '#98c5f3',
    },
    manaBarColor: {
      backgroundColor: '#3260d2',
    },
  })
)

interface Props {
  value: number
  valueMax: number
  editable?: boolean
  onEdit?: (value: string) => void
}

export const ManaBar: React.FC<Props> = ({ value, valueMax, editable, onEdit }) => {
  const classes = useStyles()
  return (
    <ColoredBar
      onEdit={onEdit}
      editable={editable}
      color={classes.manaBarColor}
      bgColor={classes.manaBarColorBg}
      title={'Skupienie'}
      value={value}
      valueMax={valueMax}
    />
  )
}
